/* NestByte — scrolling announcement bar
   Added by Claude. Converts the theme's fading announcement bar into a continuous
   marquee. It reads its content from the announcement blocks you edit in the theme
   editor, so adding or changing a message there just works.

   Safe to delete this file and its two lines in snippets/stylesheets.liquid to
   restore the theme's default behaviour. */
(function () {
  'use strict';

  var PIXELS_PER_SECOND = 65;

  function textOf(slide) {
    var p = slide.querySelector('.announcement-bar__text');
    return (p ? p.innerHTML : slide.textContent || '').trim();
  }

  function build(component) {
    if (!component || component.getAttribute('data-nb-marquee') === 'on') return;

    var slides = Array.prototype.slice.call(component.querySelectorAll('.announcement-bar__slide'));
    var items = slides
      .map(function (slide) {
        var link = slide.querySelector('.announcement-bar__link');
        return { html: textOf(slide), href: link ? link.getAttribute('href') : null };
      })
      .filter(function (item) {
        return item.html !== '';
      });

    if (!items.length) return;

    var marquee = document.createElement('div');
    marquee.className = 'nb-marquee';

    var viewport = document.createElement('div');
    viewport.className = 'nb-marquee__viewport';
    marquee.appendChild(viewport);

    var group = document.createElement('div');
    group.className = 'nb-marquee__group';
    group.innerHTML = items
      .map(function (item) {
        var tag = item.href ? 'a' : 'span';
        var href = item.href ? ' href="' + item.href + '"' : '';
        return (
          '<' + tag + ' class="nb-marquee__item"' + href + '>' + item.html + '</' + tag + '>' +
          '<span class="nb-marquee__sep" aria-hidden="true"></span>'
        );
      })
      .join('');
    viewport.appendChild(group);

    component.setAttribute('data-nb-marquee', 'on');
    component.appendChild(marquee);

    // Duplicate the run of messages until it comfortably overfills the bar, so the
    // loop point is never visible, then set the duration from the measured width to
    // keep the scroll speed identical on every screen size.
    requestAnimationFrame(function () {
      var groupWidth = group.scrollWidth;
      if (!groupWidth) return;

      var containerWidth = marquee.offsetWidth || window.innerWidth || 1000;
      var copies = Math.max(2, Math.ceil((containerWidth * 2) / groupWidth) + 1);

      for (var i = 1; i < copies; i++) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        viewport.appendChild(clone);
      }

      viewport.style.setProperty('--nb-shift', groupWidth + 'px');
      viewport.style.setProperty('--nb-duration', (groupWidth / PIXELS_PER_SECOND).toFixed(2) + 's');
    });
  }

  function buildAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var components = scope.querySelectorAll('announcement-bar-component');
    Array.prototype.forEach.call(components, build);
  }

  function start() {
    buildAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-run after the theme editor re-renders the header section.
  document.addEventListener('shopify:section:load', function (event) {
    buildAll(event.target);
  });

  // Re-measure on resize (debounced) so the speed stays consistent after a rotate.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var components = document.querySelectorAll('announcement-bar-component[data-nb-marquee="on"]');
      Array.prototype.forEach.call(components, function (component) {
        var existing = component.querySelector('.nb-marquee');
        if (existing) existing.remove();
        component.removeAttribute('data-nb-marquee');
        build(component);
      });
    }, 250);
  });
})();
